import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { DropDown } from 'app/components/Common/Animation/DropDown'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { styles, theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import React, { memo } from 'react'
import { Parallax } from 'react-scroll-parallax'

export interface Props {
  image: ImageProps
  title?: string
}

export const Banner = memo(function Banner({ image, title }: Props) {
  if (!image) {
    return null
  }

  return (
    <Container>
      <DropDown>
        <Wrapper>
          <Parallax className="item-parallax" translateY={['-20%', '20%']}>
            <Image {...image} />
          </Parallax>

          {title ? <Title delay={-0.85} length={80} text={title} /> : null}
        </Wrapper>
      </DropDown>
    </Container>
  )
})

const Test = styled.div``

const Container = styled.section`
  padding: 5vw;
  margin-top: 5.5rem;

  @media (max-width: 1199px) {
    margin-top: 4.25rem;
    padding: 1.5rem;
  }
`

const Wrapper = styled.div`
  aspect-ratio: 1.9;
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;

  > .item-parallax {
    position: relative;
    height: 100%;

    &:before {
      content: '';
      width: 100%;
      height: 50%;
      background: linear-gradient(
        ${rgba(theme.colors.variants.neutralDark3, 0)},
        ${rgba(theme.colors.variants.neutralDark3, 0.8)}
      );
      backface-visibility: hidden;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (max-width: 1199px) {
    aspect-ratio: 0.9;
  }
`

const Title = styled(AnimatedTitle)`
  ${styles.title.normal}

  position: absolute;
  z-index: 1;
  right: 5vw;
  bottom: 3.75rem;
  color: ${theme.colors.variants.neutralLight3};

  @media (max-width: 1199px) {
    left: 1.5rem;
    right: 1.5rem;
    bottom: 3rem;
  }
`
